module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACAAAAAgCAYAAABzenr0AAAAAXNSR0IArs4c6QAAAUNJREFUWEdjZBhgwDjA9jOMOmA0BEZDYDQEiA4Bl+vbt///9794r7bXNWoWXiQ4YNt/BgaGvwyM/2f+YfxXf0Dd9w01HEKqA2B2fmRgYGgR/Pdl0mrtsF+UOIRcB8DsvMfA8L9sj6b3WnIdQakDIPYy/j/MyMBQtFvD+wypDqGOAyC2gtLI4n9Mf6v2qfs+JdYh1HQAzM5v//8zJu/V8lxBjCOo7YAfjAwMzb9fcHYdcHT8Q1cH/GdgOMTA8D91r6b3LWIshqmhRgh8/M/AWL5Xw2MWAyMjKB2QBChzwH/GjYxMzFm7NdyekWQrkmJyHfDiPyND7l4NrzXkWkx+FPxnmMf+51/JVj2f95RaDi5CiDXE5dq2O0xMDGm7NLz2EauHGHVEO8Dy8SrO47Jh34kxlBQ1RDuAFENJUTvqgNEQGA0BAFsKcyGscXzTAAAAAElFTkSuQmCC"


//////////////////
// WEBPACK FOOTER
// ./src/assets/player/play2.png
// module id = BTlS
// module chunks = 1